import React from 'react';
import SocialCTAs from './SocialCTAs';

const Home = () => {
  return (
    <main
      id="home"
      className="grid flex-1 grid-cols-1 md:grid-cols-[minmax(0,1.6fr)_minmax(0,1fr)]"
    >
      <section className="flex flex-col justify-between gap-16 border-b border-brand px-6 py-8 md:border-b-0 md:border-r md:px-12 md:py-10">
        <img
          src={`${process.env.PUBLIC_URL}/jd-logo-white.png`}
          alt="JD"
          className="h-14 w-14 object-contain md:h-[88px] md:w-[88px]"
        />
        <div className="flex flex-col gap-5">
          <h1 className="m-0 text-[clamp(64px,10vw,132px)] font-extrabold leading-[0.88] tracking-[-0.05em] text-fg-strong">
            Jonas
            <br />
            Dormaels
          </h1>
          <p className="m-0 text-xl text-fg-strong md:text-[26px]">
            Freelance IT professional.
          </p>
        </div>
      </section>

      <section className="flex flex-col justify-end px-6 py-8 md:px-9 md:py-10">
        <SocialCTAs />
      </section>
    </main>
  );
};

export default Home;
